import {CustomFieldFormScrollContentOffset} from 'module/CustomField/util/CustomFieldFormScrollContentOffset'
import {css} from '@emotion/react'

export const cssCFLabelSticky = css`
	top: ${CustomFieldFormScrollContentOffset}px;
	position: sticky;
	background: #f9f9f9;
	z-index: 2;
	opacity: 0.8;
`
/* used, when 2 labels used vertically. sub label should be sticky under first label and scroll under it */
export const cssCFSubLabelSticky = css`
	top: ${CustomFieldFormScrollContentOffset + 32}px;
	position: sticky;
	background: #f9f9f9;
	z-index: 1;
	opacity: 0.8;
`
